const POST_LOGIN_REDIRECT_KEY = 'postLoginRedirect';
const POST_LOGIN_REDIRECT_MAX_AGE_MS = 30 * 60 * 1000;
const EXCLUDED_PATHS = ['/', '/login', '/signup'];

interface StoredRedirect {
    path: string;
    savedAt: number;
}

const isSafeAppPath = (path: string): boolean => path.startsWith('/') && !path.startsWith('//') && !path.startsWith('/\\');

export const savePostLoginRedirect = (pathname: string, search: string): void => {
    if (EXCLUDED_PATHS.includes(pathname) || !isSafeAppPath(pathname)) {
        return;
    }

    const stored: StoredRedirect = { path: `${pathname}${search}`, savedAt: Date.now() };
    sessionStorage.setItem(POST_LOGIN_REDIRECT_KEY, JSON.stringify(stored));
};

export const getPostLoginRedirect = (): string | null => {
    const raw = sessionStorage.getItem(POST_LOGIN_REDIRECT_KEY);
    if (!raw) {
        return null;
    }

    try {
        const stored = JSON.parse(raw) as StoredRedirect;
        const isExpired = Date.now() - stored.savedAt > POST_LOGIN_REDIRECT_MAX_AGE_MS;
        return !isExpired && typeof stored.path === 'string' && isSafeAppPath(stored.path) ? stored.path : null;
    } catch {
        return null;
    }
};

export const clearPostLoginRedirect = (): void => {
    sessionStorage.removeItem(POST_LOGIN_REDIRECT_KEY);
};

export const consumePostLoginRedirect = (): string | null => {
    const target = getPostLoginRedirect();
    if (target) {
        clearPostLoginRedirect();
    }
    return target;
};
